import Vue from 'vue';
import wrapper from './wrapper.vue';

document.addEventListener("DOMContentLoaded", () => {
  const el = document.querySelector('[data-publication-ajax]');
  const url = new URL(window.location.href);

  let inPrintParam = url.searchParams.get('in_print');
  var inPrint = true;
  if (inPrintParam == 'false') {
    inPrint = false;
  }

  let category = url.searchParams.get('category');
  if (category == null) {
    category = 'All_titles';
  }

  let pageParam = url.searchParams.get('page');
  let page = Number.parseInt(pageParam) || 1;

  if (el != undefined) {
    new Vue({
      el: '[data-publication-ajax]',
      components: { wrapper },
      data: {
        initialInPrint: inPrint,
        initialCategory: category,
        initialPage: page,
      },
      template: `<wrapper :initialInPrint=initialInPrint :initialCategory=initialCategory :initialPage=initialPage></wrapper>`
    });
  }
});
